module.exports = __webpack_public_path__ + "static/media/icon-videocall-2.2e4527c5.svg";